import Vue from "vue";
import Router from "vue-router";
import HelloWorld from "@/components/HelloWorld";
import Login from "@/components/auth/LoginPage";
import ForgotPassword from "@/components/auth/forgotPasswordPage";
import ResetPassword from "@/components/auth/resetPasswordPage";
//onboarding
import SignupBase from "@/components/onboarding/SignupBase";
import SignupBusiness from "@/components/onboarding/SignupBusiness";
import SignupPersonal from "@/components/onboarding/SignupPersonal";

import DashboardBase from "@/components/base/DashboardBase";
import OverviewPage from "@/components/dashboard/DashboardOverview";

import DisburseSingle from "@/components/disbursement/SendMoney";
import DisburseRecurring from "@/components/disbursement/ScheduledTransfers";
import DisburseBulk from "@/components/disbursement/BulkTransfers";

import TransfersList from "@/components/transfers/AllTransfers";
import BatchList from "@/components/transfers/BatchTransfers";
import DisburseOrderList from "@/components/transfers/BatchDisburseOrder";
import SingleTransfer from "@/components/transfers/SingleTransfer";
import RecurringTransfers from "@/components/transfers/RecurringTransfers";
import ScheduledTransfers from "@/components/transfers/ScheduledTransfers";
import TransfersBase from "@/components/transfers/TransfersBase";

import ApprovalsBase from "@/components/approvals/ApprovalsBase";
import AwaitingApproval from "@/components/approvals/AwaitingApproval";
import ApprovedTransfers from "@/components/approvals/ApprovedTransfers";
import CancelledTransfers from "@/components/approvals/CancelledTransfers";

import Compliance from "@/components/partials/compliance";

//wallet
import BalanceBase from "@/components/wallet/BalanceBase";
import WalletBase from "@/components/wallet/WalletBase";
import PosBase from "@/components/pos/posBase";
import MerchantPosBase from "@/components/pos/merchantPosBase";
import FundWallet from "@/components/wallet/FundWallet";
import SecondaryWallet from "@/components/wallet/SecondaryBalances";
import WalletOverview from "@/components/wallet/WalletOverview";
import FundingHistory from "@/components/wallet/FundingHistory";
import SingleBalanceBase from "@/components/wallet/SingleBalanceBase";
import SingleBalanceDisbursements from "@/components/wallet/SingleBalanceDisbursements";
import SingleBalanceFull from "@/components/wallet/SingleBalanceFull";
import SingleBalanceDetails from "@/components/wallet/SingleBalanceDetails";
import SingleBalanceFundings from "@/components/wallet/SingleBalanceFundings";
import PosOverview from "@/components/pos/posOverview";
import PosTerminals from "@/components/pos/posTerminals";
import PosAgents from "@/components/pos/posAgents";
import SinglePosBase from "@/components/pos/singlePosBase";
import SinglePosTransfers from "@/components/pos/posAgentTransfers";
import SinglePosDispenseError from "@/components/pos/dispenseError";

//settings
import SettingsBase from "@/components/settings/SettingsBase";
import GeneralSettings from "@/components/settings/GeneralSettings";
import ProfileSettings from "@/components/settings/ProfileSettings";
import NotificationsSettings from "@/components/settings/NotificationsSettings";
import APISettings from "@/components/settings/APISettings";
import TeamSettings from "@/components/settings/TeamSettings";
import ConfigSettings from "@/components/settings/configSettings";

import BeneficiariesList from "@/components/beneficiaries/BeneficiariesList";

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: "/login",
            name: "login",
            component: Login
        },
        {
            path: "/resetPassword",
            name: "reset-password",
            component: ResetPassword
        },
        {
            path: "/forgotPassword",
            name: "forgot-password",
            component: ForgotPassword
        },
        //onboarding
        {
            path: "/signup",
            name: "signup",
            component: SignupBase,
            children: [
                {
                    path: "step-1",
                    name: "signup-personal",
                    component: SignupPersonal
                },
                {
                    path: "step-2",
                    name: "signup-business",
                    component: SignupBusiness
                }
            ],
            props: { signupNav: true }
        },

        {
            path: "/",
            name: "dashboard",
            component: DashboardBase,

            children: [
                //dashboard overview
                { path: "overview", name: "overview", component: OverviewPage },

                //send money pages
                {
                    path: "disburse/single",
                    name: "single-disburse",
                    component: DisburseSingle
                },
                {
                    path: "disburse/single/:id",
                    name: "single-disburse-id",
                    component: DisburseSingle
                },
                {
                    path: "disburse/recurring",
                    name: "schedule-recurring",
                    component: DisburseRecurring
                },
                {
                    path: "disburse/bulk",
                    name: "bulk-disburse",
                    component: DisburseBulk
                },

                // POS
                {
                    path: "pos",
                    name: "pos",
                    component: MerchantPosBase,
                    redirect: { name: "pos-overview" },
                    children: [
                        {
                            path: "merchant",
                            name: "merchant",
                            component: PosBase,
                            children: [
                                {
                                    path: "overview",
                                    name: "pos-overview",
                                    component: PosOverview
                                },
                                {
                                    path: "terminals",
                                    name: "pos-terminals",
                                    component: PosTerminals
                                },
                                {
                                    path: "agents",
                                    name: "pos-agents",
                                    component: PosAgents
                                }
                            ]
                        },
                        {
                            path: "balance",
                            name: "balance",
                            component: SinglePosBase,
                            children: [
                                {
                                    path: ":id/overview",
                                    name: "single-pos-overview",
                                    component: PosOverview
                                },
                                {
                                    path: ":id/transfer-history",
                                    name: "single-agent-transfers",
                                    component: SinglePosTransfers
                                },
                                {
                                    path: ":id/dispense-error",
                                    name: "single-agent-dispenseError",
                                    component: SinglePosDispenseError
                                }
                            ]
                        }
                    ]
                },

                //wallet and funding pages
                {
                    path: "wallet",
                    name: "wallet",
                    component: BalanceBase,
                    redirect: { name: "wallet-overview" },
                    children: [
                        {
                            path: "balances",
                            name: "balances",
                            component: WalletBase,
                            children: [
                                {
                                    path: "overview",
                                    name: "wallet-overview",
                                    component: WalletOverview
                                },
                                {
                                    path: "funding-history",
                                    name: "all-fundings",
                                    component: FundingHistory
                                },
                                {
                                    path: "fund",
                                    name: "fund-wallet",
                                    component: FundWallet
                                },
                                {
                                    path: "Secondary",
                                    name: "secondary-wallet",
                                    component: SecondaryWallet
                                }
                            ]
                        },
                        {
                            path: "balance",
                            name: "balance",
                            component: SingleBalanceBase,
                            children: [
                                {
                                    path: ":id/funding-history",
                                    name: "single-balance-fundings",
                                    component: SingleBalanceFundings
                                },
                                {
                                    path: ":id/disbursements",
                                    name: "single-balance-disbursements",
                                    component: SingleBalanceDisbursements
                                },
                                {
                                    path: ":id/full-history",
                                    name: "single-balance-full",
                                    component: SingleBalanceFull
                                },
                                {
                                    path: ":id/details",
                                    name: "single-balance-details",
                                    component: SingleBalanceDetails
                                }
                            ]
                        }
                    ]
                },

                //single wallet page

                //transfers
                {
                    path: "transfers",
                    name: "transfers",
                    component: TransfersBase,
                    redirect: { name: "all-transfers" },
                    children: [
                        {
                            path: "all",
                            name: "all-transfers",
                            component: TransfersList
                        },
                        {
                            path: "batch",
                            name: "batch-transfers",
                            component: BatchList
                        },
                        {
                            path: "batch/:id",
                            name: "disburse-transfers",
                            component: DisburseOrderList
                        },
                        {
                            path: "recurring",
                            name: "recurring-transfers",
                            component: RecurringTransfers
                        },
                        {
                            path: "scheduled",
                            name: "scheduled-transfers",
                            component: ScheduledTransfers
                        },
                        {
                            path: "detail/:id",
                            name: "single-transfer",
                            component: SingleTransfer
                        }
                    ]
                },

                //approvals
                {
                    path: "approvals",
                    name: "approvals",
                    component: ApprovalsBase,
                    redirect: { name: "awaiting-approval" },
                    children: [
                        {
                            path: "awaiting",
                            name: "awaiting-approval",
                            component: AwaitingApproval
                        },
                        {
                            path: "approved",
                            name: "approved-transfers",
                            component: ApprovedTransfers
                        },
                        {
                            path: "cancelled",
                            name: "cancelled-transfers",
                            component: CancelledTransfers
                        }
                    ]
                },

                //beneficiaries
                {
                    path: "beneficiaries",
                    name: "beneficiaries",
                    component: BeneficiariesList
                },

                // compliance
                {
                    path: "compliance",
                    name: "compliance",
                    component: Compliance
                },

                //settings
                {
                    path: "settings",
                    name: "settings",
                    component: SettingsBase,
                    children: [
                        {
                            path: "general",
                            name: "general-settings",
                            component: GeneralSettings
                        },
                        {
                            path: "team",
                            name: "team-settings",
                            component: TeamSettings
                        },
                        {
                            path: "config",
                            name: "config-settings",
                            component: ConfigSettings
                        },
                        {
                            path: "profile",
                            name: "profile-settings",
                            component: ProfileSettings
                        },
                        {
                            path: "api",
                            name: "API-settings",
                            component: APISettings
                        },
                        {
                            path: "notifications",
                            name: "notification-settings",
                            component: NotificationsSettings
                        }
                    ]
                }
            ]
        }
    ],
    linkActiveClass: "active"
    // mode: 'history',
});



// WEBPACK FOOTER //
// ./src/router/index.js